(function createOchayaProductV2Core(global) {
  'use strict';

  const PREVIEW_SESSION_KEY = 'ochaya-tray-preview-checkout-block-v1';

  const COPY = Object.freeze({
    nb: Object.freeze({
      locale: 'nb',
      numberLocale: 'nb-NO',
      chooseMatcha: 'Velg matcha',
      addToCart: 'Legg i handlekurven',
      inStock: 'På lager',
      soldOut: 'Utsolgt',
      orderSummary: 'Din bestilling',
      addingToCart: 'Legger til i handlekurven …',
      addedToCart: 'Lagt i handlekurven ✓',
      refreshingCart: 'Oppdaterer handlekurven',
      retry: 'Prøv igjen',
      checkCart: 'Åpne handlekurven',
      productImages: 'Produktbilder',
      previousImage: 'Forrige bilde',
      nextImage: 'Neste bilde',
      cartRejected: 'Shopify kunne ikke legge varene i handlekurven.',
      cartOutcomeUnknown:
        'Varene kan være lagt til. Kontroller handlekurven før du prøver igjen.',
      cartCommittedRefreshFailed:
        'Varene er lagt til. Åpne handlekurven for å oppdatere visningen.',
      checkoutBlocked:
        'Vi kunne ikke bekrefte at trebrettet er gratis. Fjern tilbudet eller prøv igjen før du går til kassen.',
      emptySelection: 'Velg minst én variant.',
      equipmentColorLegend: 'Velg farge på utstyrssettet',
      equipmentColorHint: 'Velg mellom fargene som er på lager.',
      equipmentImageAlt: 'Komplett Ochaya matchasett',
      equipmentSetName: 'Komplett utstyrssett',
      productOne: 'Produkt 1',
      equipmentUnavailable: 'Utstyrssettet er utsolgt.',
      volumeSavings: (amount) =>
        `Du sparer ${amount}. Rabatten trekkes automatisk i handlekurven.`,
      volumeRemaining: (count) =>
        `Legg til ${count} ${count === 1 ? 'produkt' : 'produkter'} til. Kombiner boks og refill som du vil.`,
      trayProgressLabel: 'Fremdrift mot gratis trebrett',
      trayGiftPending: 'Trebrett i gave når du velger tre matchaprodukter',
      productCount: (count) => `${count} ${count === 1 ? 'produkt' : 'produkter'}`,
      trayImageAlt: 'Lite Ochaya-trebrett',
    }),
    en: Object.freeze({
      locale: 'en',
      numberLocale: 'en-NO',
      chooseMatcha: 'Choose matcha',
      addToCart: 'Add to cart',
      inStock: 'In stock',
      soldOut: 'Sold out',
      orderSummary: 'Your order',
      addingToCart: 'Adding to cart …',
      addedToCart: 'Added to cart ✓',
      refreshingCart: 'Updating cart',
      retry: 'Try again',
      checkCart: 'Open cart',
      productImages: 'Product images',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      cartRejected: 'Shopify could not add the items to the cart.',
      cartOutcomeUnknown:
        'The items may have been added. Check your cart before trying again.',
      cartCommittedRefreshFailed:
        'The items were added. Open the cart to refresh the view.',
      checkoutBlocked: "We couldn't verify that the tray is free. Remove the offer or try again before checkout.",
      emptySelection: 'Choose at least one variant.',
      equipmentColorLegend: 'Choose the equipment set color',
      equipmentColorHint: 'Choose from the colors currently in stock.',
      equipmentImageAlt: 'Complete Ochaya matcha set',
      equipmentSetName: 'Complete equipment set',
      productOne: 'Product 1',
      equipmentUnavailable: 'The equipment set is sold out.',
      volumeSavings: (amount) =>
        `You save ${amount}. The discount is applied automatically in the cart.`,
      volumeRemaining: (count) =>
        `Add ${count} more ${count === 1 ? 'product' : 'products'}. Combine tins and refills as you like.`,
      trayProgressLabel: 'Progress towards a free wooden tray',
      trayGiftPending: 'Wooden tray gift when you choose three matcha products',
      productCount: (count) => `${count} ${count === 1 ? 'product' : 'products'}`,
      trayImageAlt: 'Small Ochaya wooden tray',
    }),
  });

  const ENGLISH_REPLACEMENTS = new Map([
    ['Gratis frakt over', 'Free shipping over'],
    ['Levering i Norge 1–3 virkedager', 'Delivery in Norway in 1–3 business days'],
    ['Våre tegårder', 'Our tea farms'],
    ['Slik lager du matcha', 'How to prepare matcha'],
    ['Om Ochaya', 'About Ochaya'],
    ['Butikk', 'Shop'],
    ['Meny', 'Menu'],
    ['Handlekurv', 'Cart'],
    ['Ujitawara · Kyoto', 'Ujitawara · Kyoto'],
    ['Steinmalt Uji-matcha', 'Stone-milled Uji matcha'],
    ['På lager', 'In stock'],
    ['Utsolgt', 'Sold out'],
    ['Smaksprofil', 'Tasting profile'],
    ['Kremet · frisk · mild umami', 'Creamy · fresh · gentle umami'],
    [
      'Myk og balansert Uji-matcha fra familieeide tegårder i Ujitawara. Nyt den ren, med melk eller i en matchalatte.',
      'Smooth and balanced Uji matcha from family-owned tea farms in Ujitawara. Enjoy it straight, with milk, or as a matcha latte.',
    ],
    ['Velg matcha og antall', 'Choose matcha and quantity'],
    ['Kombiner gjerne flere størrelser i samme bestilling.', 'Feel free to combine several sizes in the same order.'],
    ['Google-anmeldelser', 'Google reviews'],
    ['Din bestilling', 'Your order'],
    ['Bestillingen din', 'Your order'],
    ['Dine valg', 'Your selection'],
    ['Velg matcha', 'Choose matcha'],
    ['Velg boks eller refill, størrelse og antall. Du kan kombinere variantene i samme bestilling.', 'Choose a tin or refill, size, and quantity. You can combine variants in one order.'],
    ['Gjør ritualet komplett', 'Complete your ritual'],
    ['Valgfritt', 'Optional'],
    ['Komplett utstyrssett · 5 deler', 'Complete equipment set · 5 pieces'],
    ['Matchabolle · visp · holder · skje · sil', 'Matcha bowl · whisk · holder · spoon · sifter'],
    ['Totalt', 'Total'],
    ['Trygg betaling · Lagerstatus kontrolleres i kassen', 'Secure payment · Availability is confirmed at checkout'],
    ['Velg emballasje, størrelse og antall.', 'Choose packaging, size, and quantity.'],
    ['Emballasje', 'Packaging'],
    ['Har du allerede en tett boks?', 'Do you already have an airtight tin?'],
    ['Boks', 'Tin'],
    ['Forseglet for best mulig friskhet', 'Sealed for lasting freshness'],
    ['Refill', 'Refill'],
    ['For deg som allerede har en boks', 'For those who already have a tin'],
    ['Størrelse', 'Size'],
    ['2 gram per kopp', '2 grams per cup'],
    ['Ca. 20 kopper · fin for å starte', 'About 20 cups · a good place to start'],
    ['Ca. 50 kopper · for daglig bruk', 'About 50 cups · for daily use'],
    ['Antall', 'Quantity'],
    ['Juster med minus og pluss', 'Adjust with minus and plus'],
    ['Boks · 40 g', 'Tin · 40 g'],
    ['Boks · 100 g', 'Tin · 100 g'],
    ['Refill · 40 g', 'Refill · 40 g'],
    ['Refill · 100 g', 'Refill · 100 g'],
    ['per kopp', 'per cup'],
    ['Legg i handlekurven', 'Add to cart'],
    ['Legg til komplett utstyrssett', 'Add the complete tool set'],
    ['Matchabolle, visp, holder, skje og sil', 'Matcha bowl, whisk, holder, spoon, and sieve'],
    ['fra 207 anmeldelser', 'from 207 reviews'],
    ['i Oslo', 'in Oslo'],
    ['matcha', 'matcha'],
    ['Boks og refill', 'Tins and refills'],
    ['Kombiner gjerne boks og refill', 'Feel free to combine tins and refills'],
    ['Forseglet · ca. 20 kopper', 'Sealed · approx. 20 cups'],
    ['Forseglet · ca. 50 kopper', 'Sealed · approx. 50 cups'],
    ['For deg som har en tett boks', 'If you already have an airtight tin'],
    ['Velg tre matchaprodukter og få 10 %', 'Choose three matcha products and get 10% off'],
    ['Komplett utstyrssett', 'Complete equipment set'],
    ['Derfor Ochaya', 'Why Ochaya'],
    ['Matcha du faktisk får lyst til å lage igjen.', 'Matcha you will genuinely want to make again.'],
    [
      'God matcha skal være enkel å velge, enkel å vispe og så god at den blir en del av hverdagen.',
      'Good matcha should be easy to choose, easy to whisk, and good enough to become part of your daily routine.',
    ],
    ['Velg størrelse', 'Choose a size'],
    ['Boks eller refill · 40 g eller 100 g', 'Tin or refill · 40 g or 100 g'],
    ['Mild og kremet smak', 'Mild and creamy taste'],
    ['Balansert umami og lite bitterhet – god med vann, melk eller plantedrikk.', 'Balanced umami with little bitterness — delicious with water, milk, or a plant-based drink.'],
    ['Fra Ujitawara i Kyoto', 'From Ujitawara in Kyoto'],
    ['Fra Ujitawara til koppen', 'From Ujitawara to the cup'],
    ['Utvalgt fra familieeide samarbeidsgårder i et av Japans historiske teområder.', 'Selected from family-owned partner farms in one of Japan’s historic tea regions.'],
    ['Steinmalt for fin tekstur', 'Stone-milled for a fine texture'],
    ['Tencha males til et fint pulver som vispes jevnt og gir en myk munnfølelse.', 'Tencha is milled into a fine powder that whisks smoothly with a soft mouthfeel.'],
    ['Rundt 20 kopper i 40 g', 'Around 20 cups per 40 g'],
    ['Bruk omtrent 2 g per kopp, og juster styrken etter smak.', 'Use about 2 g per cup and adjust the strength to taste.'],
    ['Start med boks, fyll på med refill', 'Start with a tin, top up with a refill'],
    ['Velg en forseglet boks første gang. Har du allerede en tett boks, kan du velge refill.', 'Choose a sealed tin the first time. If you already have an airtight tin, choose a refill.'],
    ['10 % på tre matchaprodukter', '10% off three matcha products'],
    ['Kombiner boks og refill i samme bestilling. Rabatten trekkes automatisk i handlekurven.', 'Combine tins and refills in one order. The discount is applied automatically in the cart.'],
    ['Smaken, fortalt av dere', 'The taste, in your words'],
    ['Matcha som blir husket', 'Matcha worth remembering'],
    ['Basert på 207 anmeldelser', 'Based on 207 reviews'],
    ['Google-anmeldelse', 'Google review'],
    ['Les alle på Google →', 'Read all reviews on Google →'],
    ['Et lite ritual · hver dag', 'A small ritual · every day'],
    ['En roligere stund. Bare deg og matcha.', 'A calmer moment. Just you and matcha.'],
    ['Matcha trenger ikke være komplisert. Sikt, visp og ta et lite øyeblikk før dagen fortsetter.', 'Matcha does not need to be complicated. Sift, whisk, and take a quiet moment before the day continues.'],
    ['Tradisjonell matcha', 'Traditional matcha'],
    ['Matchalatte', 'Matcha latte'],
    ['Slik holder den seg frisk', 'How to keep it fresh'],
    ['Produktfakta', 'Product facts'],
    ['Kort om matchaen', 'About this matcha'],
    ['Opprinnelse', 'Origin'],
    ['Fra produktinformasjonen', 'From the product information'],
    ['Kategori', 'Category'],
    ['Ingrediens', 'Ingredient'],
    ['100 % grønn te', '100% green tea'],
    ['Innhold', 'Contents'],
    ['Kultivar', 'Cultivar'],
    ['Oppgitt av Ochaya', 'Provided by Ochaya'],
    ['Innhøsting', 'Harvest'],
    ['Første innhøsting', 'First harvest'],
    ['Foredling', 'Processing'],
    ['Tradisjonelt steinmalt', 'Traditionally stone-milled'],
    ['Åpenhet først', 'Transparency first'],
    ['Kun dokumenterte opplysninger publiseres som produktfakta.', 'Only documented information is published as product facts.'],
    ['Tre enkle steg', 'Three simple steps'],
    ['Sikt', 'Sift'],
    ['Sikt 2 g matcha i bollen.', 'Sift 2 g of matcha into the bowl.'],
    ['Tilsett vann', 'Add water'],
    ['Hell over 60 ml vann ved ca. 75 °C.', 'Add 60 ml of water at about 75 °C.'],
    ['Visp', 'Whisk'],
    ['Visp raskt i W-bevegelser til fint skum.', 'Whisk quickly in a W motion until finely foamed.'],
    ['Sør-Kyoto · matchaens fødested', 'Southern Kyoto · the birthplace of matcha'],
    ['Fra tefjellene i Ujitawara.', 'From the tea hills of Ujitawara.'],
    ['Kyoto-prefekturet', 'Kyoto Prefecture'],
    ['Sørøst i Kyoto', 'Southeast of Kyoto'],
    ['Ujitawara · Kyoto-prefekturet · Japan', 'Ujitawara · Kyoto Prefecture · Japan'],
    ['Her fikk matcha sin form.', 'Where matcha took shape.'],
    ['Sted', 'Place'],
    ['Tradisjon', 'Tradition'],
    ['Råvare', 'Raw material'],
    ['Kilder og kartlisens', 'Sources and map licence'],
    ['Fra tencha til matcha', 'From tencha to matcha'],
    ['Steinmalt til et fint pulver.', 'Stone-milled into a fine powder.'],
    ['Matcha trekkes ikke som vanlig te. Hele bladet males til et fint pulver som vispes direkte i vann.', 'Matcha is not steeped like ordinary tea. The whole leaf is milled into a fine powder and whisked directly into water.'],
    ['Skyggedyrket tencha', 'Shade-grown tencha'],
    ['Metode', 'Method'],
    ['Tradisjonell steinmaling', 'Traditional stone milling'],
    ['Resultat', 'Result'],
    ['Fint pulver som vispes direkte', 'Fine powder, whisked directly'],
    ['Foto og faktagrunnlag', 'Photo and factual sources'],
    ['Fra åkeren', 'From the fields'],
    ['Se hvor teen begynner', 'See where the tea begins'],
    ['Se en kort film fra Ochayas besøk i teåkrene i Uji.', 'Watch a short film from Ochaya’s visit to the tea fields of Uji.'],
    ['Fortsett ritualet', 'Continue the ritual'],
    ['Passer godt sammen', 'Pairs well with'],
    ['Bambusvisp', 'Bamboo whisk'],
    ['En tradisjonell bambusvisp som gjør det enklere å få et fint, kremet skum.', 'A traditional bamboo whisk that makes it easier to create a fine, creamy foam.'],
    ['Se bambusvispen →', 'View the bamboo whisk →'],
    ['Gavesett med matcha', 'Matcha gift set'],
    ['Et komplett ritual, samlet og klart til å gis bort.', 'A complete ritual, collected and ready to give.'],
    ['Se gavesettet →', 'View the gift set →'],
    ['Ofte stilte spørsmål', 'Frequently asked questions'],
    ['Før du velger.', 'Before you choose.'],
    ['Korte svar om variantene, tilberedning, oppbevaring og bestilling.', 'Short answers about variants, preparation, storage, and ordering.'],
    ['Hva er forskjellen på boks og refill?', 'What is the difference between a tin and a refill?'],
    ['Hvor mye matcha bruker jeg per kopp?', 'How much matcha should I use per cup?'],
    ['Hvordan lager jeg matchaen?', 'How do I prepare the matcha?'],
    ['Hvordan oppbevarer jeg matchaen?', 'How should I store the matcha?'],
    ['Hvordan fungerer mengderabatten?', 'How does the volume discount work?'],
    ['Hva gjelder for levering og retur?', 'What applies to delivery and returns?'],
    ['Levering og betaling', 'Delivery and payment'],
    ['Trygg betaling', 'Secure payment'],
    ['Velg betalingsmåte i kassen', 'Choose a payment method at checkout'],
    ['Levering i Norge', 'Delivery in Norway'],
    ['Normalt 1–3 virkedager', 'Normally 1–3 business days'],
    ['Frakt beregnes i kassen', 'Shipping is calculated at checkout'],
    ['Velg levering i kassen', 'Choose delivery at checkout'],
    ['Tilgjengelige fraktvalg', 'Available delivery options'],
    ['Postkasse og pakkeboks', 'Mailbox and parcel locker'],
    ['Gratis henting', 'Free pickup'],
    ['Betal med', 'Pay with'],
    ['Tilgjengelige betalingsmåter', 'Available payment methods'],
    ['Retur og refusjon', 'Returns and refunds'],
    ['Se gjeldende vilkår →', 'View current terms →'],
    ['Forstørret produktbilde', 'Enlarged product image'],
    ['Lukk bildet', 'Close image'],
    ['Forstørr bilde', 'Enlarge image'],
    ['Fra pulver til ferdig kopp', 'From powder to finished cup'],
    ['Lag den slik du liker den.', 'Prepare it the way you like it.'],
    ['Følg fire enkle trinn, og drikk den ren, med melk eller over is.', 'Follow four simple steps and enjoy it straight, with milk, or over ice.'],
    ['Tilgjengelighet bekreftes når varene legges i handlekurven.', 'Availability is confirmed when the items are added to the cart.'],
    ['Produktet er utsolgt.', 'The product is sold out.'],
    ['Legger til i handlekurven …', 'Adding to cart …'],
    ['Oppdaterer handlekurven', 'Refreshing the cart'],
    ['Lagt i handlekurven ✓', 'Added to cart ✓'],
    ['Velg en variant', 'Choose a variant'],
    ['Du har gratis frakt ✓', 'You have free shipping ✓'],
    ['Gratisgaven vises i handlekurven.', 'The free gift is shown in the cart.'],
    ['Prøv igjen', 'Try again'],
    ['Forrige bilde', 'Previous image'],
    ['Neste bilde', 'Next image'],
    ['Produktbilder', 'Product images'],
    ['10 % mengderabatt er aktiv', '10% volume discount is active'],
    ['Mengderabatt (10 %)', 'Volume discount (10%)'],
    ['Produkt 1', 'Product 1'],
    ['Produkt 2 · Gratis gave', 'Product 2 · Free gift'],
    ['Kuroyuri · 5 deler', 'Kuroyuri · 5 pieces'],
    ['Ochaya-trebrett · lite', 'Ochaya wooden tray · small'],
    ['Inkludert', 'Included'],
    ['Pakkepris', 'Bundle price'],
    ['Valgt produkt', 'Selected product'],
    ['Låst', 'Locked'],
    ['Fremdrift', 'Progress'],
    ['Gaveverdi', 'Gift value'],
    ['Tilbud valgt', 'Offer selected'],
    ['Tre matchaprodukter valgt · tilbudet er klart', 'Three matcha products selected · the offer is ready'],
    ['Kjøp settet og få trebrettet gratis', 'Buy the set and receive the wooden tray free'],
    [
      'Kombiner boks og refill som du vil. Ved tre får du også 10 % mengderabatt.',
      'Combine tins and refills as you like. At three, you also receive a 10% volume discount.',
    ],
    [
      'Du har valgt to separate produkter og betaler bare for utstyrssettet.',
      'You selected two separate products and only pay for the equipment set.',
    ],
    [
      'Du får to separate produkter og betaler bare for utstyrssettet.',
      'You receive two separate products and only pay for the equipment set.',
    ],
    ['Legger til…', 'Adding…'],
    ['Lagt til ✓', 'Added ✓'],
    ['Handlekurven er oppdatert.', 'The cart has been updated.'],
    ['Bestillingen er lagt til ✓', 'Order added ✓'],
    ['En eller flere valgte varianter er ikke tilgjengelige.', 'One or more selected variants are unavailable.'],
    ['Noe gikk galt. Prøv igjen.', 'Something went wrong. Try again.'],
    ['Uji-matcha', 'Uji matcha'],
    ['207 Google-anmeldelser', '207 Google reviews'],
    ['4,9', '4.9'],
    ['4,9 av 5', '4.9 out of 5'],
    ['Ochaya Uji-matcha i boks med en liten skål matchapulver', 'Ochaya Uji matcha tin with a small bowl of matcha powder'],
    ['Ochaya Uji-matcha 40 g', 'Ochaya Uji matcha, 40 g'],
    ['Ochaya grønn matchaboks', 'Ochaya green matcha tin'],
    ['Ochaya Uji-matcha i studio', 'Ochaya Uji matcha in a studio setting'],
    ['Ochaya Uji-matcha ovenfra', 'Overhead view of Ochaya Uji matcha'],
    ['Ochaya Uji-matcha 100 g', 'Ochaya Uji matcha, 100 g'],
    ['Ochaya refillpose', 'Ochaya refill pouch'],
    ['Velg matchavarianter', 'Choose matcha variants'],
    ['Ochaya Uji-matcha boks 40 gram', 'Ochaya Uji matcha tin, 40 grams'],
    ['Ochaya Uji-matcha boks 100 gram', 'Ochaya Uji matcha tin, 100 grams'],
    ['Ochaya Uji-matcha refill 40 gram', 'Ochaya Uji matcha refill, 40 grams'],
    ['Ochaya Uji-matcha refill 100 gram', 'Ochaya Uji matcha refill, 100 grams'],
    ['Antall Boks 40 gram', 'Quantity, 40-gram tin'],
    ['Antall Boks 100 gram', 'Quantity, 100-gram tin'],
    ['Antall Refill 40 gram', 'Quantity, 40-gram refill'],
    ['Antall Refill 100 gram', 'Quantity, 100-gram refill'],
    ['Fjern én Boks 40 gram', 'Remove one 40-gram tin'],
    ['Fjern én Boks 100 gram', 'Remove one 100-gram tin'],
    ['Legg til én Boks 40 gram', 'Add one 40-gram tin'],
    ['Legg til én Boks 100 gram', 'Add one 100-gram tin'],
    ['Fjern én Refill 40 gram', 'Remove one 40-gram refill'],
    ['Fjern én Refill 100 gram', 'Remove one 100-gram refill'],
    ['Legg til én Refill 40 gram', 'Add one 40-gram refill'],
    ['Legg til én Refill 100 gram', 'Add one 100-gram refill'],
    ['Komplett Ochaya matchasett', 'Complete Ochaya matcha set'],
    ['Kort om steinmalingen', 'About stone milling'],
    ['Tradisjonell ishi-usu · Uji, Kyoto', 'Traditional ishi-usu · Uji, Kyoto'],
    ['Tencha males til grønt matchapulver mellom tradisjonelle granittsteiner i Uji, Kyoto', 'Tencha being ground into green matcha powder between traditional granite stones in Uji, Kyoto'],
    ['Fra åkeren', 'From the tea fields'],
    ['Ochaya i Uji · 00:29', 'Ochaya in Uji · 00:29'],
    ['Ochaya gavesett', 'Ochaya gift set'],
    ['Alt du trenger til matcharitualet, samlet i ett gavesett.', 'Everything you need for the matcha ritual, gathered in one gift set.'],
    ['Oslo, Sandvika og Bergen', 'Oslo, Sandvika, and Bergen'],
    ['Korte svar om variantene, tilberedning, oppbevaring og bestilling.', 'Quick answers about variants, preparation, storage, and ordering.'],
    ['Innholdet er den samme Uji-matchaen. Boksen er forseglet og laget for oppbevaring. Refill passer for deg som allerede har en ren, tett boks.', 'The contents are the same Uji matcha. The tin is sealed and designed for storage. A refill is suitable if you already have a clean, airtight tin.'],
    ['Start med omtrent 2 g per kopp, og juster mengden etter hvor mild eller kraftig du vil ha den.', 'Start with about 2 g per cup and adjust the amount depending on how mild or strong you want it.'],
    ['Sikt pulveret, tilsett varmt vann og visp til et fint skum. Drikk den ren, med melk eller servert over is.', 'Sift the powder, add hot water, and whisk to a fine foam. Enjoy it straight, with milk, or served over ice.'],
    ['Lukk emballasjen godt, og oppbevar matchaen kjølig, mørkt og tørt. Følg datomerkingen på emballasjen.', 'Close the packaging tightly and store the matcha in a cool, dark, dry place. Follow the date marking on the packaging.'],
    ['Velg til sammen tre Uji-matchaprodukter. Du kan kombinere boks og refill, og rabatten på 10 % trekkes automatisk i handlekurven.', 'Choose a total of three Uji matcha products. You can combine tins and refills, and the 10% discount is applied automatically in the cart.'],
    ['Les gjeldende vilkår for retur og refusjon.', 'Read the current return and refund terms.'],
    ['Etter damping og tørking fjernes stilker og bladnerver. Bladene blir da til tencha, som males mellom granittsteiner til et fint, grønt pulver. Dette er det siste steget i fremstillingen av Ochayas Uji-matcha.', 'After steaming and drying, stems and leaf veins are removed. The leaves then become tencha, which is milled between granite stones into a fine green powder. This is the final step in producing Ochaya’s Uji matcha.'],
    ['Prosessbeskrivelsen bygger på Japans landbruksdepartement (MAFF). Foto: Jochen Meyer, tatt i Uji i Kyoto;', 'The process description is based on Japan’s Ministry of Agriculture, Forestry and Fisheries (MAFF). Photo: Jochen Meyer, taken in Uji, Kyoto;'],
    [', nedskalert for previewen.', ', resized for this preview.'],
    ['Illustrativ kurve som sammenligner opplevd energi og fokus fra matcha og kaffe', 'Illustrative chart comparing the perceived energy and focus from matcha and coffee'],
    ['Fem trinn fra Ujitawara og første innhøsting til ferdig Uji-matcha', 'Five steps from Ujitawara and the first harvest to finished Uji matcha'],
    ['Fire illustrerte trinn for å sikte, tilsette vann, vispe og ferdigstille matcha', 'Four illustrated steps for sifting, adding water, whisking, and finishing matcha'],
    ['Ren matcha, matchalatte og matcha servert over is', 'Straight matcha, matcha latte, and matcha served over ice'],
    ['En jevnere vei til fokus', 'A smoother path to focus'],
    ['Slik lager du perfekt matcha', 'How to make perfect matcha'],
    ['Tre måter å servere matcha', 'Three ways to serve matcha'],
    ['«Dette må være den beste matchaen jeg noen gang har smakt!»', '“This must be the best matcha I have ever tasted!”'],
    ['«Her brukes matcha av ypperste kvalitet med riktig utstyr og tilbehør.»', '“They use top-quality matcha with the proper equipment and accessories.”'],
    ['«En skikkelig god matcha i Oslo som får meg til å føle jeg er tilbake i Japan.»', '“Really good matcha in Oslo that makes me feel as though I am back in Japan.”'],
    ['Utdrag fra offentlige Google-anmeldelser. Per 24. august 2026 var vurderingen 4,9 av 5, basert på 207 anmeldelser.', 'Translated excerpts from public Google reviews. As of 24 August 2026, the rating was 4.9 out of 5 based on 207 reviews.'],
  ]);

  const ENGLISH_PATTERNS = [
    [/^Fra (.+)$/u, 'From $1'],
    [/^Kun (.+) til gratis frakt$/u, 'Only $1 until free shipping'],
    [/^Gratis fra (.+)$/u, 'Free shipping from $1'],
    [/^(\d+) vare$/u, '$1 item'],
    [/^(\d+) varer$/u, '$1 items'],
    [/^Legg \d+ (?:vare|varer) i handlekurven(?: · .+)?$/u, 'Add to cart'],
    [/^(\d+) × Boks · (40|100) g$/u, '$1 × Tin · $2 g'],
    [/^(\d+) × Komplett utstyrssett$/u, '$1 × Complete equipment set'],
    [/^Du sparer (.+)$/u, 'You save $1'],
    [/^For deg som har en tett boks · spar (.+)$/u, 'If you already have an airtight tin · save $1'],
    [/^Ordinær pris (.+)$/u, 'Regular price $1'],
    [/^Verdi (.+)$/u, 'Value $1'],
    [/^1 vare lagt i handlekurven\.?$/u, '1 item added to the cart.'],
    [/^(\d+) varer lagt i handlekurven\.?$/u, '$1 items added to the cart.'],
    [/^1 vare lagt i handlekurven\. Gratisgaven vises i handlekurven\.$/u, '1 item added to the cart. The free gift is shown in the cart.'],
    [/^(\d+) varer lagt i handlekurven\. Gratisgaven vises i handlekurven\.$/u, '$1 items added to the cart. The free gift is shown in the cart.'],
    [/^1 item added to the cart\. The free gift is shown in the cart\.$/u, '1 item added to the cart. The free gift is shown in the cart.'],
    [/^(\d+) items added to the cart\. The free gift is shown in the cart\.$/u, '$1 items added to the cart. The free gift is shown in the cart.'],
    [/^Legg til (\d+) produkt til\./u, 'Add $1 more product.'],
    [/^Legg til (\d+) produkter til\./u, 'Add $1 more products.'],
    [/^Velg 1 matchaprodukt til og få trebrettet gratis$/u, 'Choose 1 more matcha product and receive the wooden tray free'],
    [/^Velg (\d+) matchaprodukter til og få trebrettet gratis$/u, 'Choose $1 more matcha products and receive the wooden tray free'],
    [/^Velg 1 matchaprodukt til$/u, 'Choose 1 more matcha product'],
    [/^Velg (\d+) matchaprodukter til$/u, 'Choose $1 more matcha products'],
    [/^Utstyrssett valgt · (\d+) av 3 matchaprodukter$/u, 'Equipment set selected · $1 of 3 matcha products'],
    [/^(\d+) av 3 matchaprodukter$/u, '$1 of 3 matcha products'],
    [/^Tilbudet er lagt til · (.+) ✓$/u, 'Offer added · $1 ✓'],
    [/^Legg til tilbudet · (.+)$/u, 'Add offer · $1'],
    [/^Trebrett i gave · ordinær pris (.+)$/u, 'Wooden tray gift · regular price $1'],
    [/^Vis produktbilde (\d+) av (\d+): (.+)$/u, 'Show product image $1 of $2: $3'],
    [/^Fjern én Boks (40|100) gram$/u, 'Remove one $1-gram tin'],
    [/^Legg til én Boks (40|100) gram$/u, 'Add one $1-gram tin'],
    [/^Fjern én Refill (40|100) gram$/u, 'Remove one $1-gram refill'],
    [/^Legg til én Refill (40|100) gram$/u, 'Add one $1-gram refill'],
    [/^Leveringsvalg og pris vises i kassen\. Du får gratis frakt over (.+)\.$/u, 'Delivery options and prices are shown at checkout. You receive free shipping over $1.'],
    [/^Forstørr grafikken (.+)$/u, 'Enlarge the graphic $1'],
    [/^ca\. (.+) per kopp$/u, 'about $1 per cup'],
  ];

  const SORTED_ENGLISH_REPLACEMENTS = [...ENGLISH_REPLACEMENTS].sort(
    ([left], [right]) => right.length - left.length,
  );

  function isEnglish(locale) {
    return String(locale || '').toLowerCase().startsWith('en');
  }

  function copyFor(locale) {
    return isEnglish(locale) ? COPY.en : COPY.nb;
  }

  function localizePath(path, localeRoot) {
    const value = String(path || '/');
    const root = String(localeRoot || '/').replace(/\/$/u, '');
    if (!root || root === '/' || value === root || value.startsWith(root + '/')) return value;
    return root + (value.startsWith('/') ? value : '/' + value);
  }

  function translateText(value, locale) {
    if (!isEnglish(locale) || typeof value !== 'string' || !value.trim()) return value;
    const leading = value.match(/^\s*/u)?.[0] || '';
    const trailing = value.match(/\s*$/u)?.[0] || '';
    let translated = value.trim();

    const exactReplacement = ENGLISH_REPLACEMENTS.get(translated);
    if (exactReplacement) {
      translated = exactReplacement;
    } else {
      for (const [pattern, replacement] of ENGLISH_PATTERNS) {
        translated = translated.replace(pattern, replacement);
      }
      for (const [norwegian, english] of SORTED_ENGLISH_REPLACEMENTS) {
        if (translated.includes(norwegian)) translated = translated.replaceAll(norwegian, english);
      }
    }
    for (const [pattern, replacement] of ENGLISH_PATTERNS) translated = translated.replace(pattern, replacement);
    return leading + translated + trailing;
  }

  function translateSubtree(root, copy) {
    if (!root || copy.locale !== 'en') return;
    const ownerDocument = root.ownerDocument || global.document;
    const showText = global.NodeFilter?.SHOW_TEXT ?? 4;
    const walker = ownerDocument?.createTreeWalker?.(root, showText);
    let node = walker?.nextNode?.();
    while (node) {
      const translated = translateText(node.nodeValue || '', copy.locale);
      if (translated !== node.nodeValue) node.nodeValue = translated;
      node = walker.nextNode();
    }

    const elements = root.matches?.('*') ? [root, ...root.querySelectorAll('*')] : [...(root.querySelectorAll?.('*') || [])];
    for (const element of elements) {
      for (const attribute of ['aria-label', 'alt', 'title']) {
        if (!element.hasAttribute?.(attribute)) continue;
        const current = element.getAttribute(attribute) || '';
        const translated = translateText(current, copy.locale);
        if (translated !== current) element.setAttribute(attribute, translated);
      }
    }
  }

  function observeLocalizedTree(root, copy) {
    if (!root || copy.locale !== 'en' || typeof global.MutationObserver !== 'function') {
      translateSubtree(root, copy);
      return { disconnect() {} };
    }

    translateSubtree(root, copy);
    const observer = new global.MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          const current = mutation.target.nodeValue || '';
          const translated = translateText(current, copy.locale);
          if (translated !== current) mutation.target.nodeValue = translated;
          continue;
        }
        if (mutation.type === 'attributes') {
          translateSubtree(mutation.target, copy);
          continue;
        }
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 3) {
            const translated = translateText(node.nodeValue || '', copy.locale);
            if (translated !== node.nodeValue) node.nodeValue = translated;
          } else {
            translateSubtree(node, copy);
          }
        }
      }
    });
    observer.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'alt', 'title'],
    });
    return observer;
  }

  function collectSectionIds(documentObject) {
    return [...documentObject.querySelectorAll('cart-items-component[data-section-id]')]
      .map((element) => element.dataset.sectionId)
      .filter(Boolean)
      .filter((value, index, values) => values.indexOf(value) === index);
  }

  async function readJson(response, { fallbackOnError = false } = {}) {
    try {
      return await response.json();
    } catch (error) {
      if (fallbackOnError) return {};
      throw error;
    }
  }

  async function addItemsAndRefresh({
    fetcher,
    cartAddUrl,
    cartJsonUrl,
    items,
    sectionIds = [],
    sectionsUrl,
    onCommitted,
  }) {
    const payload = { items, sections_url: sectionsUrl };
    if (sectionIds.length > 0) payload.sections = [...new Set(sectionIds)].join(',');

    let addResponse;
    try {
      addResponse = await fetcher(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
    } catch (cause) {
      const error = new Error('The cart request ended before Shopify confirmed the result.', { cause });
      error.committed = 'unknown';
      throw error;
    }
    const addPayload = await readJson(addResponse, { fallbackOnError: true });
    const added = addPayload && typeof addPayload === 'object' && !Array.isArray(addPayload) ? addPayload : {};
    if (!addResponse.ok || added.status) {
      const error = new Error(added.description || added.message || 'Shopify could not add the items to the cart.');
      error.committed = false;
      throw error;
    }
    if (typeof onCommitted === 'function') onCommitted({ added, items });

    try {
      const cartResponse = await fetcher(cartJsonUrl, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('The cart refresh failed.');
      const cart = await readJson(cartResponse);
      if (
        !cart ||
        typeof cart !== 'object' ||
        Array.isArray(cart) ||
        !Number.isInteger(cart.item_count) ||
        cart.item_count < 0
      ) {
        throw new Error('Shopify returned an invalid cart response.');
      }
      return { committed: true, refreshed: true, added, cart, refreshError: null };
    } catch (refreshError) {
      return { committed: true, refreshed: false, added, cart: null, refreshError };
    }
  }

  function dispatchCartUpdate({ documentObject, cart, added, sourceId }) {
    if (!documentObject || !cart) return;
    documentObject.dispatchEvent(
      new global.CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId,
          data: {
            source: sourceId,
            itemCount: cart.item_count,
            sections: added?.sections || {},
          },
        },
      }),
    );
  }

  function setPreviewOfferSelected(storage, selected) {
    if (!storage) return;
    try {
      if (selected) storage.setItem(PREVIEW_SESSION_KEY, '1');
      else storage.removeItem(PREVIEW_SESSION_KEY);
    } catch (_) {
      // Session storage can be unavailable in private browsing contexts.
    }
  }

  function containsPreviewClaim(items) {
    return (
      Array.isArray(items) &&
      items.some(
        (item) =>
          item?.properties?._ochaya_tray_preview === '1' ||
          item?.properties?._ochaya_tray_preview_gift === '1',
      )
    );
  }

  function persistPreviewCheckoutBlockForOutcome({ storage, items, committed }) {
    if (!containsPreviewClaim(items) || (committed !== true && committed !== 'unknown')) return false;

    setPreviewOfferSelected(storage, true);
    return true;
  }

  function isPreviewOfferSelected(storage) {
    try {
      return storage?.getItem(PREVIEW_SESSION_KEY) === '1';
    } catch (_) {
      return false;
    }
  }

  function shouldBlockCheckout({ previewOfferSelected }) {
    return previewOfferSelected === true;
  }

  global.OchayaProductV2Core = Object.freeze({
    PREVIEW_SESSION_KEY,
    addItemsAndRefresh,
    collectSectionIds,
    containsPreviewClaim,
    copyFor,
    dispatchCartUpdate,
    isPreviewOfferSelected,
    localizePath,
    observeLocalizedTree,
    persistPreviewCheckoutBlockForOutcome,
    setPreviewOfferSelected,
    shouldBlockCheckout,
    translateText,
  });
})(globalThis);
